import React from 'react';
import './App.css';

export default function AboutMission({ onBackClick }) {
  return (
    <main className="page-content about-overview" style={{ padding: '28px 16px', paddingBottom: '180px', maxWidth: 1100, margin: '0 auto', position: 'relative' }}>
      <button
        className="back-button"
        onClick={() => onBackClick && onBackClick('home')}
        style={{
          backgroundColor: '#0b6b2f',
          color: 'white',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '14px',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}
      >
        ← ආපසු
      </button>

      <h1 style={{ color: '#0b6b2f', fontSize: 28, marginBottom: 12, textAlign: 'justify' }}>අපගේ කාර්‍යභාරය</h1>
      <hr className="footer-sep" />

      <h3 style={{ color: 'black', fontSize: 20, marginBottom: 16, marginTop: 16, textAlign: 'justify' }}><b>1. නව කෘෂිකර්මික දැනුම ව්‍යාප්ත කිරීම</b></h3>
      <ul style={{ marginLeft: 24, fontSize: 17, marginBottom: 24, textAlign: 'justify', listStyleType: 'disc' }}>
        <li>කෘෂිකාර්මික පුහුණු වැඩසටහන් ක්‍රියාත්මක කිරීම</li>
        <li>පළාතේ ජනතාවගේ කෘෂිකාර්මික දැනුම , කුසලතා හා ආකල්ප වැඩිදියුණු කිරීම</li>
        <li>කාෂි ව්‍යවසායකයින් බිහිකිරීම</li>
        <li>උසස් තත්වයේ බීජ හා රෝපන ද්‍රව්‍ය නිෂ්පාදනය</li>
        <li>කෘෂි නිෂ්පාදන ප්‍රවර්ධනය කිරීම</li>
        <li>කෘෂි නිෂ්පාදන වල ප්‍රමිතිය හා ගුණාත්මය ඉහල නැංවීම</li>
        <li>නිෂ්පාදන සමිති පිහිටුවීම</li>
      </ul>

      <h3 style={{ color: 'black', fontSize: 20, marginBottom: 16, marginTop: 24, textAlign: 'justify' }}><b>2. කෘෂිකාර්මික ප්‍රතිපත්ති හා අණපනත් ක්‍රියාත්මක කිරීම</b></h3>
      <ul style={{ marginLeft: 24, fontSize: 17, marginBottom: 24, textAlign: 'justify', listStyleType: 'disc' }}>
        <li>පලිබෝධනාශක පනත</li>
        <li>බීජ හා රෝපණ ද්‍රව්‍ය පනත</li>
        <li>පාංශු සංරක්ෂණ පනත</li>
        <li>ශාක ආරක්ෂක පනත</li>
      </ul>

      <h3 style={{ color: 'black', fontSize: 20, marginBottom: 16, marginTop: 24, textAlign: 'justify' }}><b>3. තොරතුරු රැස්කිරීම</b></h3>
      <ul style={{ marginLeft: 24, fontSize: 17, marginBottom: 24, textAlign: 'justify', listStyleType: 'disc' }}>
        <li>කෘෂිකාර්මික තොරතුරු රැස්කිරීම</li>
      </ul>

      <h3 style={{ color: 'black', fontSize: 20, marginBottom: 16, marginTop: 24, textAlign: 'justify' }}><b>4. පහසුකම් සහ සේවා සැපයීම</b></h3>
      <ul style={{ marginLeft: 24, fontSize: 17, marginBottom: 24, textAlign: 'justify', listStyleType: 'disc' }}>
        <li>කෘෂි නිෂ්පාදන ඵළදායීතාවය ඉහල නැංවීම සදහා අවශ්‍ය සේවා හා පහසුකම් සැපයීම</li>
        <li>ස්වයංක්‍රීය ස්වභාවික සම්පත් කළමණාකරණය සදහා මගපෙන්වීම හා සහසුකම් සැපයීම</li>
        <li>තාක්ෂණික උපකරණ ලබාදීම</li>
        <li>බෝග ආරක්ෂාව සදහා අවශ්‍ය නිර්දේශ ලබාදීම</li>
        <li>ස්වයං රැකියා උත්පාදන වැඩසටහන් ක්‍රියාත්මක කිරීම</li>
        <li>50% දායකත්වය මත කෘෂි උපකරණ හා රෝපන ද්‍රව්‍ය ලබාදීම</li>
      </ul>

      <h3 style={{ color: 'black', fontSize: 20, marginBottom: 16, marginTop: 24, textAlign: 'justify' }}><b>5. විවිධ පර්යේෂණ කටයුතු සිදුකිරීම</b></h3>
      <ul style={{ marginLeft: 24, fontSize: 17, marginBottom: 24, textAlign: 'justify', listStyleType: 'disc' }}>
        <li>ක්ෂේත්‍ර මට්ටමේ පර්යේෂණ සිදුකිරීම</li>
        <li>ජාතික මට්ටමේ පර්යේෂණ සදහා සහය වීම</li>
      </ul>
    </main>
  );
}
